// app/javascript/controllers/turbo_delete_controller.js
// Sends a DELETE request via fetch and processes the turbo_stream response.
// Use this instead of data-turbo-method="delete" when the link lives inside
// a form that has data-turbo="false" (which disables Turbo for descendants).
//
// Once confirmed it dispatches turbo-delete:start before the request, and
// turbo-delete:end when the request settles, with detail.rendered saying
// whether a turbo stream was rendered. Both bubble and carry detail.source,
// this button, so a page can hold off other changes while a removal is out
// (see input_field_picker_controller.js). If another stream has replaced the
// button meanwhile, the end is dispatched from the document instead.
import {Controller} from "stimulus";

export default class extends Controller {
    destroy(event) {
        event.preventDefault();

        const url = this.element.dataset.turboDeleteUrlValue;
        if (!url) {
            console.error("Turbo delete: missing data-turbo-delete-url-value");
            return;
        }

        const confirmMsg = this.element.dataset.turboDeleteConfirmValue;
        if (confirmMsg && !confirm(confirmMsg)) return;

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

        this.announce("start");
        fetch(url, {
            method: "DELETE",
            headers: {
                "X-CSRF-Token": csrfToken,
                "Accept": "text/vnd.turbo-stream.html"
            }
        }).then(response => {
            if (response.ok) return response.text();
            throw new Error("Delete failed");
        }).then(html => {
            if (html && html.includes("<turbo-stream")) {
                Turbo.renderStreamMessage(html);
                return true;
            }
            return false;
        }).catch(error => {
            console.error("Turbo delete failed:", error);
            return false;
        }).then(rendered => this.announce("end", {rendered}));
    }

    announce(name, detail = {}) {
        const target = this.element.isConnected ? this.element : document;
        target.dispatchEvent(new CustomEvent(`turbo-delete:${name}`, {bubbles: true, detail: {...detail, source: this.element}}));
    }
}
